import { IVehicleDataHandler } from '../../data-handlers/vehicle/IVehicleDataHandler'
import { Vehicle } from '../../entities/vehicle/Vehicle'

export class VehicleRepository {
  handler: IVehicleDataHandler

  constructor(handler: IVehicleDataHandler) {
    this.handler = handler
  }

  getVehicles(): Promise<Vehicle[]> {
    return this.handler.getVehicles()
  }
}
